import { DISABLE_LOADING, ENABLE_LOADING, SET_LOADING, TOGGLE_LOADING } from './types';

export const actions = {
    [TOGGLE_LOADING]: ({ commit }, payload) => {
        commit(SET_LOADING, !payload);
    },
    [ENABLE_LOADING]: ({ commit }) => {
        commit(SET_LOADING, true);
    },
    [DISABLE_LOADING]: ({ commit }) => {
        commit(SET_LOADING, false);
    }
};



// WEBPACK FOOTER //
// ./src/store/actions.js